module.exports = __webpack_public_path__ + "static/media/318ce2f97a8bd1d7a693938d9aff5f08.318ce2f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/318ce2f97a8bd1d7a693938d9aff5f08.svg
// module id = 989
// module chunks = 17